// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G04-","question":"styles_question__3gUlS","inputVisibleButton":"styles_inputVisibleButton__2xGeE","note":"styles_note__3fmE3"};